import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { useTheme } from '@/context/ThemeContextProvider'
import { useBaseStore } from '@/store'
import { appConfigActionsSelector } from '@/store/appConfigSlice'
import { authActionsSelector } from '@/store/authSlice'
import { useQueryClient } from '@tanstack/react-query'
import { Key, Laptop, LogOut, Moon, Sparkle, Sun } from 'lucide-react'
import { ReactNode } from 'react'
import { useNavigate } from "react-router-dom";

interface ProfileMenuProps {
    trigger: ReactNode
    className?: string
}

const ProfileMenu = ({ trigger, className }: ProfileMenuProps) => {
    const { onChangePasswordDialogOpen } = useBaseStore(
        appConfigActionsSelector
    )
            
    const navigate = useNavigate();
    const { setTheme } = useTheme()

    const { logout } = useBaseStore(authActionsSelector)

    const queryClient = useQueryClient()

    return (
        <DropdownMenu>
            <DropdownMenuTrigger className={className}>
                {trigger}
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-[220px]">
                <DropdownMenuGroup>
                    <DropdownMenuLabel>Conta</DropdownMenuLabel>
                    <DropdownMenuItem
                        className="gap-2"
                        onClick={onChangePasswordDialogOpen}
                    >
                        <Key size={14} />
                        Alterar senha
                    </DropdownMenuItem>
                </DropdownMenuGroup>
                <DropdownMenuSeparator />
                <DropdownMenuGroup>
                    <DropdownMenuLabel>
                        Tema
                        <span className="inline-flex items-center gap-1 p-1 ml-2 text-xs font-normal text-yellow-600 rounded-md bg-yellow-50 dark:bg-accent dark:text-accent-foreground">
                            <Sparkle size={11} />
                            Experimental
                        </span>
                    </DropdownMenuLabel>
                    <DropdownMenuItem
                        className="gap-2"
                        onClick={() => setTheme('light')}
                    >
                        <Sun size={14} />
                        Claro
                    </DropdownMenuItem>
                    <DropdownMenuItem
                        className="gap-2"
                        onClick={() => setTheme('dark')}
                    >
                        <Moon size={14} />
                        Escuro
                    </DropdownMenuItem>
                    <DropdownMenuItem
                        className="gap-2"
                        onClick={() => setTheme('system')}
                    >
                        <Laptop size={14} />
                        Sistema
                    </DropdownMenuItem>
                    <DropdownMenuSeparator />
                </DropdownMenuGroup>

                <DropdownMenuItem
                    className="gap-2"
                    onClick={() => {
                        logout(queryClient);
                        navigate("/login") 
                    }}
                        
                >
                    <LogOut size={14} />
                    Sair
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    )
}

export default ProfileMenu
